import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function NotFound() {
  const history = useHistory();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px",
        textAlign: "center",
        background: "var(--surface-sunken)",
      }}
    >
      <div style={{ fontSize: "96px", fontWeight: 700, color: "var(--brand-primary)", lineHeight: 1 }}>
        404
      </div>
      <h2 style={{ margin: "16px 0 8px", color: "var(--text-strong)" }}>Page not found</h2>
      <p style={{ color: "var(--text-muted)", maxWidth: "480px", marginBottom: "24px" }}>
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <div style={{ display: "flex", gap: "12px" }}>
        <Button variant="primary" onClick={() => history.push("/")}>
          Go to home
        </Button>
        <Button variant="secondary" onClick={() => history.goBack()}>
          Go back
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
